module.exports = __webpack_public_path__ + "img/t5-10.344e52aa.svg";